import { ConfirmationEnum } from "@/central-atoms/enums/generic";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";

export function useDriverSelfCheckIn() : boolean {
    return useSelector(
        (state: RootState) => (state.driverDetails.details?.data?.user?.additional_props?.external_user_props?.self_check_in === ConfirmationEnum.Yes)
    );
}

export function useTyreEntryCheck(): boolean {
    // By default true
    return useSelector((state: RootState) => !(state.loginDetails.details?.tyre_entry_check === false));
}

export function useSelfCheckInDetails() {
    return useSelector((state: RootState) => state.selfCheckInDetails);
}

export function useFeatureFlags() {
    return useSelector((state: RootState) => state.featureFlags);
}